<template>
    <div>
      <vx-card>
        <vs-table pagination :max-items="10" search :data="contracts">

          <template slot="header" vs-justify="flex-end">
            <router-link :to="{name: 'accounting-contract-add'}" >
                <vs-button vs-order="5" radius color="primary" icon-pack="feather" icon="icon-plus" v-if="pms ('AccountingContract', 'create', 'b')"></vs-button>
            </router-link>
          </template>

          <template slot="thead">
            <vs-th sort-key="contractNo">{{ $t("sections.accounting.dataForm.contractNo") }}</vs-th>
            <vs-th sort-key="contractDate">{{ $t("sections.accounting.dataForm.contractDate") }}</vs-th>
            <vs-th sort-key="contractName">{{ $t("sections.accounting.dataForm.contractName") }}</vs-th>
            <vs-th sort-key="loanType">{{ $t("sections.accounting.dataForm.loan.loanType") }}</vs-th>
            <vs-th sort-key="contractAmount">{{ $t("sections.accounting.dataForm.contractAmount") }}</vs-th>
            <vs-th sort-key="contractStatus">{{ $t("sections.accounting.dataForm.contractStatus") }}</vs-th>
            <vs-th sort-key="" class="w-1/12"></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.contractNo">
                {{ tr.contractNo }} <b><u>{{ tr.contractSeq }}</u></b>
              </vs-td>
              <vs-td :data="tr.contractDate">
                {{ tr.contractDate | convYYYYMMDDToDDMMYYYY }}
              </vs-td>
              <vs-td :data="tr.contractName">
                {{ tr.contractName }}
              </vs-td>
              <vs-td :data="tr.loan.loanType">
                {{ tr.loan.loanType | loanType}}
              </vs-td>
              <vs-td :data="tr.contractAmount">
                {{ tr.contractAmount | numberFormat  }}
              </vs-td>
              <vs-td :data="tr.contractStatus">
                <a>{{ tr.contractStatus | contractStatus }} </a>
              </vs-td>
              <vs-td>
                <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                  <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-file-text" @click="print(tr.id, tr.createdWith)" ></vs-button>
                  <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-edit" v-if="pms ('AccountingContract', 'edit', 'b') && tr.actions.edit" @click="edit(tr.id)"></vs-button>
                  <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-trash" v-if="pms ('AccountingContract', 'delete', 'b') && tr.contractStatus ==='Draft' && tr.actions.delete" @click="del(tr.id)" ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { isExternalUser as fncIsExternalUser } from "@/utils";
const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting')

export default {
  async created () {
    const vm = this
    const { getContracts, getContractsCreatedByCurrentUser } = vm
    if (fncIsExternalUser()){
      await getContractsCreatedByCurrentUser()
    }else{
      await getContracts()
    }
    vm.pms ('AccountingContract', 'visible', 'r')
  },
  filters: {
    periods: function (res) {
      if( res.periods.length >= 2 ){
        return res.periods[0].name +" - "+ res.periods[1].name
      }else if( res.periods.length === 1 ){
        return res.periods[0].name +" - "+ res.periods[0].name
      }else{
        return ""
      }
    }
  },
  computed: {
    ...mapAccountingFields(['contracts', 'status']),
  },
  methods: {
    ...mapAccountingActions(['getContracts', 'getContractsCreatedByCurrentUser', 'deleteContract', 'forceDeleteContract']),
    async print (id, createdWith) {
      if (createdWith === 'SmartApp') {
        await this.$router.push({name: 'accounting-contract-print-sale', params: {id: id}})
      }else{
        await this.$router.push({name: 'accounting-contract-print', params: {id: id}})
      }
    },
    async edit (id) {
      await this.$router.push({ name: 'accounting-contract-edit', params: {id: id} })
    },
    async del (id) {
      this.actionID = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('notification.confirm-delete-title'),
        text: this.$t('notification.confirm-delete-message'),
        accept: this.acceptDel
      })
    },
    async acceptDel () {
      await this.deleteContract({
        form: {
          id: this.actionID
        },
        vm: this
      })
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
}
</script>
